
























































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mapState } from 'vuex'
import CategoryModel from '@/_models/CategoryModel'

@Component({
  components: {},
  computed: {},
})
export default class SearchCategory extends Vue {
  // Props
  @Prop()
  selectedData!: any
  // data
  currentPage: number = 1
  perPage: number = 10
  numofPage: number = 1
  isFormModalActive: boolean = false
  searchQuery: string = ''
  selectedFilter: string = 'name'
  selected: any = { _id: '', name: '' }

  filedNameLUT: any = {
    _id: 'UUID',
    name: 'label.category_name',
    category_1: 'label.category_1',
    category_2: 'label.category_2',
    category_3: 'label.category_3',
  }

  // computed
  get categories(): CategoryModel[] {
    const categories = this.$store.state.categories.all.items
    this.numofPage = Math.ceil(categories.length / this.perPage)

    return categories
  }

  get isLoading(): boolean {
    return this.$store.state.categories.loading
  }

  get filteredData(): CategoryModel[] {
    const targetField: string = this.selectedFilter
    if (!this.categories) {
      return []
    }

    return this.categories.filter((item: any): boolean => {
      return (
        String(item[targetField])
          .toLowerCase()
          .indexOf(this.searchQuery.toLowerCase()) !== -1
      )
    })
  }

  convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  handleSelectFinished(): void {
    const selectedData = {
      _id: this.selected._id || '',
      name: this.selected.name || '',
    }

    this.$emit('handleSelectedCatDone', selectedData)
  }

  handleToggleSelected(): void {
    if (this.selected._id) {
      this.selected = {}
    }
  }

  // After page created
  created() {
    this.$store.dispatch('categories/getAll').then(() => {
      for (const item of this.filteredData) {
        if (
          typeof this.selectedData !== 'undefined' &&
          this.selectedData &&
          item._id === this.selectedData._id
        ) {
          this.selected = item
          return
        }
      }
    })
  }
}
